// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"459":"ccdd6620","540":"ccdd6620","681":"ccdd6620","742":"6cc2a730","903":"ccdd6620","963":"ccdd6620"}[chunkId] + ".chunk.css";
};